import Login from "./Login";
import Page from "./Page";
import PageLoading from "./PageLoading";
import SectionLoading from "./SectionLoading";
export default { Login: Login, Page: Page, PageLoading: PageLoading, SectionLoading: SectionLoading };
//# sourceMappingURL=index.js.map